export default "__VITE_ASSET__Bn17IgMY__"